import { useSelector } from "react-redux";
import { useAppDispatch } from "../../hooks/redux";
import { Skeleton } from "primereact/skeleton";
import Error from "../common/Error";
import FilterCard from "./FilterCard";
import FilterBox from "./FilterBox";
import { RootState } from "../../store";
import { teachersApi } from "../../services/teachers/teachersApi";
import { TeacherResponse } from "../../models/dtos";
import { getSelectedFaculties } from "../../services/protocols/protocolsSlice";
type TeacherFilterProps = {
  getSelectedTeachers: (state: RootState) => TeacherResponse[];
  setSelectedTeachers: any;
};

const TeacherFilter = ({ getSelectedTeachers, setSelectedTeachers }: TeacherFilterProps) => {
  const selectedTeachers = useSelector(getSelectedTeachers);
  const selectedFaculties = useSelector(getSelectedFaculties);
  const dispatch = useAppDispatch();

  const {
    data: teachers,
    error,
    isLoading,
  } = teachersApi.useGetTeachersQuery({
    byFaculty: selectedFaculties.map((faculty) => ({ id: faculty.facultyId })),
  });

  if (isLoading) return <Skeleton className="w-full h-2rem" />;
  if (error) return <Error error={error} />;

  return (
    <FilterCard title="По преподавател:">
      <FilterBox<TeacherResponse>
        filter
        value={selectedTeachers}
        onChange={(e) => dispatch(setSelectedTeachers(e.value))}
        options={teachers?.data ?? []}
        optionLabelText={(teacher: TeacherResponse) => `${teacher.firstName} ${teacher.middleName} ${teacher.lastName}`}
        listClassName="max-h-20rem"
        dataKey="teacherId"
      />
    </FilterCard>
  );
};

export default TeacherFilter;
